module.exports = __webpack_public_path__ + "images/assets/d6dffabaf27723428adc55294c15fa12.svg";